'use strict';

module.exports = function (element) {
    var hasFixedHeader = $('header').hasClass('fixed-header');
    var hasFixedHeaderEnhanced = $('header').hasClass('fixed-header-enhanced');
    var position = 0;

    if (element && element.length) {
        if (hasFixedHeader || hasFixedHeaderEnhanced) {
            var headerNavHeight = $('.header-nav').length ? $('.header-nav').height() : 0;
            var headerBannerHeight = $('.header-banner').length ? $('.header-banner').height() : 0;
            var utilityBannerHeight = $('.utility-header').length ? $('.utility-header').height() : 0;
            var fullHeaderHeight = (headerNavHeight + headerBannerHeight + utilityBannerHeight) * 2;

            if (element.offset().top > fullHeaderHeight) {
                position = element.length ? element.offset().top - headerNavHeight : 0;
            }
        } else {
            position = element.offset().top;
        }
    }

    $('html, body').animate({
        scrollTop: position
    }, 500);

    if (!element) {
        $('.logo-home').focus();
    }
};
